const readResponseMessage = (data) => {
  if (typeof data === 'string') return data;
  if (data && typeof data.error === 'string') return data.error;
  if (data && typeof data.message === 'string') return data.message;
  return '';
};

export const getDeclarationSaveErrorMessage = (error) => {
  const responseMessage = readResponseMessage(error?.response?.data);
  if (responseMessage) return responseMessage;

  if (error?.code === 'permission-denied') {
    return 'You do not have permission to save this declaration. Please sign in again or contact an administrator.';
  }

  if (error?.code === 'ECONNABORTED' || error?.message === 'Network Error') {
    return 'The declaration could not be saved because the server could not be reached. Check your connection and try again.';
  }

  return 'The declaration could not be saved. Please try again. If the problem continues, contact support.';
};
